export interface StorageAddressParts {
  building: string;
  floor: string;
  cabinet: string;
  compartment: string;
  subCompartment: string;
}

// Festes Lagerortformat der Materialentnahme:
// 16O 220 01 05 = Gebäude 16, Ebene O, Lagerort 220, Feld 01, Fach 05.
export const STORAGE_ADDRESS_PATTERN = /^\d{2}[A-Z]\s\d{3}\s\d{2}\s\d{2}$/;

export function normalizeStorageAddress(value: string): string {
  const compact = value
    .normalize("NFKC")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");

  // Nur eindeutige 10-stellige Werte werden automatisch übernommen.
  // Damit kann z. B. "03E 0301" niemals als gültiger Lagerort im Feld landen.
  if (!/^\d{2}[A-Z]\d{7}$/.test(compact)) {
    return "";
  }

  return `${compact.slice(0, 3)} ${compact.slice(3, 6)} ${compact.slice(6, 8)} ${compact.slice(8, 10)}`;
}

export function isValidStorageAddress(value: string): boolean {
  return STORAGE_ADDRESS_PATTERN.test(value.trim().toUpperCase());
}

export function parseStorageAddress(value: string): StorageAddressParts | null {
  const normalized = normalizeStorageAddress(value);
  if (!normalized) return null;

  return {
    building: normalized.slice(0, 2),
    floor: normalized.slice(2, 3),
    cabinet: normalized.slice(4, 7),
    compartment: normalized.slice(8, 10),
    subCompartment: normalized.slice(11, 13),
  };
}

export function formatStorageAddressDisplay(value: string): string {
  const normalized = normalizeStorageAddress(value);
  return normalized || value.trim();
}
